module.exports = __webpack_public_path__ + "img/nuestro_trabajo_3.66e047eb.jpg";